import { useContext } from 'react';

import { PkpassContextInterface, PkpassContext } from './PkpassContext';

export function usePkpass(): PkpassContextInterface {
  return useContext<PkpassContextInterface>(PkpassContext);
}
